/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import {
  LexicalErrorBoundary,
  LexicalEditorRefPlugin,
  LexicalHistoryPlugin,
  LexicalComposerContext,
} from '@fluentui-copilot/react-text-editor';
import { BasicFunctionalityPlugin } from '@fluentui-copilot/react-chat-input-plugins';
import type { EditorInputState, EditorInputContextValues, EditorInputSlots } from './EditorInput.types';

/**
 * Render the final JSX of EditorInput
 */
export const renderEditorInput_unstable = (
  state: EditorInputState,
  contextValues: EditorInputContextValues,
): JSXElement => {
  assertSlots<EditorInputSlots>(state);

  return (
    <state.root>
      <LexicalComposerContext.Provider value={contextValues.lexicalComposer}>
        <state.textPlugin contentEditable={<state.input />} ErrorBoundary={LexicalErrorBoundary} placeholder={null} />
        <>
          {state.placeholderValue ? <state.placeholderValue /> : null}
          <BasicFunctionalityPlugin
            onContentChange={state.handleOnChange}
            onPaste={state.onPaste}
            trimWhitespace={state.trimWhiteSpace}
            isSentinelNodeEnabled={state.isSentinelNodeEnabled}
          />
          {state.history && <LexicalHistoryPlugin />}
          {state.editorRef && <LexicalEditorRefPlugin editorRef={state.editorRef} />}
        </>
      </LexicalComposerContext.Provider>
    </state.root>
  );
};
